// getters
const schoolRoutesMessenger = state => state.schoolRoutesMessenger

export default {
  schoolRoutesMessenger
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/messenger/getters.js